import axios from "axios";
import { cleareAuthDataAction } from "../redux/actions/auth";
import store from "../redux/store";

const removeToken = () => {
  if (localStorage.getItem("access_token")) {
    localStorage.removeItem("access_token");
  }
};

const axiosInstance = axios.create({
  baseURL: `https://api.honestmaps.com`,
  //baseURL: `https://cors-anywhere.herokuapp.com/https://api.honestmaps.com`,
  //baseURL: `https://cors-anywhere.herokuapp.com/https://api.honestmaps.com`,
  headers: {
    "Content-Type": `application/json`,
    Accept: "application/json",
    /*mode: "no-cors"*/
  }
});

axiosInstance.interceptors.request.use(
  config => {
    const token = localStorage.getItem("access_token");
    if (token && token !== null) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (
      error.response &&
      error.response.data.message &&
      error.response.data.message === "token.expired"
    ) {
      removeToken();
      store.dispatch(cleareAuthDataAction());
      localStorage.removeItem("access_token");
    }
    if (error.response.status === 401) {
      store.dispatch(cleareAuthDataAction());
      localStorage.removeItem("access_token");
    }

    //   if (error.response.status === 403) {
    //     window.location.assign("/auth/login-page");
    //   }
    return Promise.reject(error);
  }
);

export default axiosInstance;
